const copytext = (element, offer) => {
    navigator.clipboard.writeText(offer);
    element.classList.add('mpo-active');
    setTimeout(() => {
        element.classList.remove('mpo-active');
    }, 500);
}

let collapsableClick = (element) => {
    // console.log(element.classList)
    if(element.classList.contains('cop-active')) element.classList.remove('cop-active')
    else element.classList.add('cop-active')
}

